module.exports = __webpack_public_path__ + "img/perfil.fd1db779.png";